import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    notifications: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_NOTIFICATION_SELECT_IDS (store, ids) {
      store.notifications.selectIds = ids
    },
    REMOVE_NOTIFICATION_SELECT_IDS (store, ids) {
      store.notifications.selectIds = store.notifications.selectIds.filter((v) => { return !ids.includes(v) })
    },
    ADDEND_NOTIFICATION_SELECT_IDS (store, ids) {
      store.notifications.selectIds = store.notifications.selectIds.concat(ids)
    },
    SET_NOTIFICATION_SELECT_ID (store, id) {
      store.notifications.selectId = id
    },
    SET_NOTIFICATION_FILTERS (store, filters) {
      store.notifications.filters = filters
    },
    SET_NOTIFICATION_PAGINATE (store, val) {
      store.notifications.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getNotifications: (store, getters) => {
      return store.notifications.selectIds.map((id) => {
        return getters['entities/notifications/find'](id)
      })
    },
    getNotificationsFilters: (store, getters) => {
      return store.notifications.filters
    },
    getNotificationsPaginate: (store, getters) => {
      return store.notifications.paginate
    },
    getNotification: (store, getters) => {
      return getters['entities/notifications/find'](store.notifications.selectId) || {}
    }
  },
  actions: {
    /*
    selectNotifications
    */
    selectNotifications ({commit, dispatch, getters, state}, filters) {
      return dispatch('getNotifications', filters)
      .then((response) => {
        commit('SET_NOTIFICATION_FILTERS', filters)
        commit('SET_NOTIFICATION_PAGINATE', response)
        commit('SET_NOTIFICATION_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    selectMoreNotifications
    */
    selectMoreNotifications ({commit, dispatch, getters, state}, filters) {
      return dispatch('getNotifications', filters)
      .then((response) => {
        commit('SET_NOTIFICATION_PAGINATE', response)
        commit('ADDEND_NOTIFICATION_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectNotifications
    */
    refreshSelectNotifications ({commit, dispatch, getters, state}) {
      return dispatch('selectNotifications', getters.getNotificationsFilters)
    },
    /*
    selectNotification
    */
    selectNotification ({commit, dispatch, getters, state}, id) {
      return dispatch('getNotificationById', id)
      .then((response) => {
        commit('SET_NOTIFICATION_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getNotifications
    */
    getNotifications ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/notifications`, {params: filters})
      .then((response) => {
        return dispatch('entities/notifications/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.notifications || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getNotificationById
    */
    getNotificationById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/notifications/${id}`)
      .then((response) => {
        return dispatch('entities/notifications/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.notifications[0]
      })
    },
    /*
    updateAllRead
    */
    updateAllRead ({commit, dispatch, getters, state}) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/notifications/all-read`, {})
      .then((response) => {
        dispatch('setProfileCounts') // update count notifications
      })
    },
    /*
    deleteNotification
    */
    deleteNotification ({commit, dispatch, getters, state}, id) {
      commit('REMOVE_NOTIFICATION_SELECT_IDS', [id])
      return dispatch('entities/notifications/delete', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Notification.js